export default "__VITE_ASSET__DP08x5PD__"